import React, { useEffect, useState } from "react";
import { ChartBar } from "@phosphor-icons/react";
import { api } from "@/lib/api";

// Sprint 62.2 — "Prove it" scoreboard: last graded slate (DK standings CSV).
export default function ResultsScoreboard() {
  const [res, setRes] = useState(null);
  useEffect(() => { api.resultsLatest().then(setRes).catch(() => setRes(null)); }, []);
  if (!res || !res.published_at) return null;
  const proj = res.projection || {};
  const own = res.ownership || {};
  const pf = res.portfolio || {};
  const positions = ["QB", "RB", "WR", "TE", "DST"];
  return (
    <section className="bg-[#0a0a0a] border border-zinc-800 p-4" data-testid="results-scoreboard">
      <div className="flex items-center justify-between gap-2 flex-wrap mb-3">
        <div className="flex items-center gap-2">
          <ChartBar size={14} weight="fill" className="text-[#39FF14]" />
          <div className="overline">Last Slate · Graded vs DK Results</div>
        </div>
        <div className="mono text-[9px] uppercase tracking-widest text-zinc-500">
          {res.label || res.slate_dg || "slate"} · {new Date(res.published_at).toLocaleDateString()} · {res.n_rows} players
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-3">
        <Stat label="Projection MAE" value={proj.available ? `${proj.overall?.mae} pts` : "—"} sub={proj.available && proj.overall?.corr != null ? `corr ${proj.overall.corr}` : ""} testId="results-proj-mae" />
        <Stat label="Ownership MAE" value={own.overall?.mae != null ? `${own.overall.mae} pp` : "—"} sub={own.overall?.bias != null ? `bias ${own.overall.bias > 0 ? "+" : ""}${own.overall.bias}` : ""} testId="results-own-mae" />
        <Stat label="Market vs Ours" value={proj.by_source?.market ? `${proj.by_source.market.mae} / ${proj.by_source.fallback?.mae ?? "—"}` : "—"} sub="MAE market-covered / fallback" testId="results-source" />
        <Stat label="Your Best Lineup" value={pf.available ? `${pf.best?.actual} pts` : "—"} sub={pf.available ? `#${pf.best?.lineup_id} · avg ${pf.avg_actual} vs ${pf.avg_projection} proj` : "no portfolio graded"} testId="results-best-lineup" />
      </div>
      {proj.available && (
        <div className="grid grid-cols-5 gap-1" data-testid="results-by-pos">
          {positions.map((p) => (
            <div key={p} className="border border-zinc-900 px-2 py-1.5 text-center">
              <div className="mono text-[9px] uppercase tracking-widest text-zinc-500">{p}</div>
              <div className="mono text-sm font-bold text-white">{proj.by_pos?.[p]?.mae ?? "—"}</div>
              <div className="mono text-[9px] text-zinc-600">n={proj.by_pos?.[p]?.n ?? 0}</div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}

function Stat({ label, value, sub, testId }) {
  return (
    <div className="border border-zinc-900 bg-black/40 px-3 py-2">
      <div className="mono text-[9px] uppercase tracking-widest text-zinc-500">{label}</div>
      <div className="mono text-lg font-black text-[#39FF14]" data-testid={testId}>{value}</div>
      {sub ? <div className="mono text-[9px] text-zinc-500 truncate">{sub}</div> : null}
    </div>
  );
}
